import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Checkbox,
  Col,
  ControlLabel,
  Form,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  Modal,
  Panel,
  PanelGroup,
  Table
} from 'react-bootstrap'

import { browserHistory } from 'react-router'
import { SortableContainer, SortableElement, SortableHandle, arrayMove, } from 'react-sortable-hoc';
import { Typeahead } from 'react-bootstrap-typeahead';

import Collapsible from '../collapsible'
import CompanyNavigation from './companynavigation'
import DatePicker from 'react-bootstrap-date-picker'
import Loadable from 'react-loading-overlay'

Date.prototype.yyyymmdd = function () {
  var mm = this.getMonth() + 1
  var dd = this.getDate()

  return [this.getFullYear(),
  (mm > 9 ? '' : '0') + mm,
  (dd > 9 ? '' : '0') + dd
  ].join('-')
}

const DragHandle = SortableHandle(() => <span style={{ cursor: "move" }}><Glyphicon glyph="menu-hamburger" /></span>); // This can be any component you want

const SortableItem = SortableElement(({ data, indexId, openEditHardwareModal, deleteInvoiceItem, formatTaxExempt }) => {
  return (
    <tr>
      <td><DragHandle /></td>
      <td>{data.hardwareName}</td>
      <td>{data.description}</td>
      <td>{data.quantity}</td>
      <td>{data.cost}</td>
      <td>{formatTaxExempt(data.taxExempt)}</td>
      <td>
        <Button bsSize="small" bsStyle="warning" onClick={() => { openEditHardwareModal(indexId) }}><i className="fa fa-pencil" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={data.id} onClick={() => { deleteInvoiceItem(data.id, indexId) }}><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </td>
    </tr>
  );
});

const SortableList = SortableContainer(({ items, openEditHardwareModal, deleteInvoiceItem, formatTaxExempt }) => {
  return (
    <Table>
      <thead>
        <tr>
          <td></td>
          <td>Item</td>
          <td>Description</td>
          <td>Quantity</td>
          <td>Cost</td>
          <td>Tax Exempt</td>
          <td>Actions</td>
        </tr>
      </thead>
      <tbody>
        {
          (items && items.length > 0)
            ? items.map((item, index) => {
              return <SortableItem key={`item-${index}`} index={index} indexId={index} data={item} openEditHardwareModal={openEditHardwareModal.bind(this)} deleteInvoiceItem={deleteInvoiceItem.bind(this)} formatTaxExempt={formatTaxExempt.bind(this)} />
            })
            : <tr><td>No data</td></tr>
        }
      </tbody>
    </Table>
  );
});

@observer(['activities', 'backends', 'updateintervals', 'paymentintervals', 'carriers', 'terms', 'agreements', 'invoices', 'companies', 'addresses', 'shippingtypes', 'globals', 'quickbooks'])
export default class InvoiceDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showHardwareModal: false,
      showAccessoryModal: false,
      showFeatureModal: false,
      showShippingModal: false,
      showNoteModal: false,
      showEditHardwareModal: false,
      hardwareTotal: 0.0,
      accessoriesTotal: 0.0,
      featuresTotal: 0.0,
      serviceTotal: 0.0,
      companyId: 0,
      taxRate: 0.0,
      invoiceTax: 0.0,
      invoiceTotal: 0.0,
      activationCostDetail: 0.0,
      shippingCostDetail: 0.0,
      serviceDetailsTotal: 0.0,
      closeDateDetail: '',
      closePercentageDetail: 0,
      noteDetail: '',
      defaultBackendId: 0,
      selectedBackendId: 0,
      defaultBackendName: '',
      selectedBackendName: '',
      defaultServiceId: 0,
      selectedServiceId: 0,
      defaultServiceName: '',
      selectedServiceName: '',
      defaultPaymentIntervalId: 0,
      selectedPaymentIntervalId: 0,
      defaultPaymentIntervalName: '',
      selectedPaymentIntervalName: '',
      defaultCarrierId: 0,
      selectedCarrierId: 0,
      defaultCarrierName: '',
      selectedCarrierName: '',
      defaultContractTermId: 0,
      selectedContractTermId: 0,
      defaultContractTermName: '',
      selectedContractTermName: '',
      defaultTaxRateId: 0,
      selectedTaxRateId: 0,
      defaultTaxRateName: '',
      selectedTaxRateName: '',
      defaultPaymentTermId: 0,
      selectedPaymentTermId: 0,
      defaultPaymentTermName: '',
      selectedPaymentTermName: '',
      defaultShippingTypeId: 0,
      selectedShippingTypeId: 0,
      defaultShippingTypeName: '',
      selectedShippingTypeName: '',
      defaultAgreementId: 0,
      selectedAgreementId: 0,
      defaultAgreementName: '',
      selectedAgreementName: '',
      addHardwareId: 0,
      addHardwareName: '',
      addHardwareDescription: '',
      addHardwareCost: '',
      addAccessoryId: 0,
      addAccessoryName: '',
      addFeatureId: 0,
      addFeatureName: '',
      billingAddressId: 0,
      shippingAddressId: 0,
      hardwareList: [],
      editHardwareId: 0,
      editHardwareName: '',
      editHardwareDescription: '',
      editHardwareQuantity: 0,
      editHardwareCost: 0,
      editHardwareTaxExempt: 0,
      originalIndexId: -1,
      quoteType: '',
      freeShipping: 0,
      loadableState: true
    }

    //this.loadAdditionalDetails(this.props);
  }

  

  async componentDidMount() {
    await this.loadAdditionalDetails(this.props);
  }

  async loadAdditionalDetails(props) {
    let promises = []

    let p1 = new Promise((resolve, reject) => {
        this.props.quickbooks.getQuickbooksCompanyItems((data) => {
            resolve(data)
        })
    })

    let p2 = new Promise((resolve, reject) => {
        this.props.quickbooks.getQuickbooksTerms((data) => {
            resolve(data)
        })
    })

    let p3 = new Promise((resolve, reject) => {
        this.props.quickbooks.getQuickbooksTaxRates((data) => {
            resolve(data)
        })
    })

    promises.push(p1)
    promises.push(p2)
    promises.push(p3)

    await Promise.all(promises).then((results) => {
      const qbItemList = results[0];
      const qbTermsList = results[1];
      const qbTaxRatesList = results[2];

      if (props.invoiceId) {
        props.loadInvoice(props.invoiceId, qbItemList, qbTermsList, qbTaxRatesList, (invoice) => {
          if (!invoice) {
            alert('We could not load this invoice due to missing Quickbooks information or synchronization issues.')
            this.setState({ loadableState: false })
            return
          }

          const newState = {
            invoiceId: props.invoiceId,
            companyId: invoice.companyId,
            quoteType: invoice.quoteType,
            hardwareTotal: invoice.hardwareTotal,
            serviceTotal: invoice.serviceTotal,
            invoiceTax: invoice.taxTotal,
            invoiceTotal: invoice.oneTimeTotal,
            shippingCostDetail: invoice.shippingCost,
            serviceDetailsTotal: invoice.monthlyTotal,
            closeDateDetail: invoice.closeDate,
            closePercentageDetail: invoice.closePercentage,
            noteDetail: invoice.note,
            defaultBackendId: invoice.backendId,
            selectedBackendId: invoice.backendId,
            defaultBackendName: invoice.backendName,
            selectedBackendName: invoice.backendName,
            defaultServiceId: invoice.serviceId,
            selectedServiceId: invoice.serviceId,
            defaultServiceName: invoice.serviceName,
            selectedServiceName: invoice.serviceName,
            defaultPaymentIntervalId: invoice.paymentIntervalId,
            selectedPaymentIntervalId: invoice.paymentIntervalId,
            defaultPaymentIntervalName: invoice.paymentIntervalName,
            selectedPaymentIntervalName: invoice.paymentIntervalName,
            defaultCarrierId: invoice.carrierId,
            selectedCarrierId: invoice.carrierId,
            defaultCarrierName: invoice.carrierName,
            selectedCarrierName: invoice.carrierName,
            defaultContractTermId: invoice.contractTermId,
            selectedContractTermId: invoice.contractTermId,
            defaultContractTermName: invoice.contractTermName,
            selectedContractTermName: invoice.contractTermName,
            defaultTaxRateId: invoice.taxRateId,
            selectedTaxRateId: invoice.taxRateId,
            defaultTaxRateName: invoice.taxRateName,
            selectedTaxRateName: invoice.taxRateName,
            defaultPaymentTermId: invoice.paymentTermId,
            selectedPaymentTermId: invoice.paymentTermId,
            defaultPaymentTermName: invoice.paymentTermName,
            selectedPaymentTermName: invoice.paymentTermName,
            defaultShippingTypeId: invoice.shippingTypeId,
            selectedShippingTypeId: invoice.shippingTypeId,
            defaultShippingTypeName: invoice.shippingTypeName,
            selectedShippingTypeName: invoice.shippingTypeName,
            defaultAgreementId: invoice.agreementId,
            selectedAgreementId: invoice.agreementId,
            defaultAgreementName: invoice.agreementName,
            selectedAgreementName: invoice.agreementName,
            billingAddressId: invoice.billingAddressId,
            shippingAddressId: invoice.shippingAddressId
          }

          if (this.state) {
            this.setState(newState);
          } else {
            this.state = newState
          }

          props.loadInvoiceItems(props.invoiceId, qbItemList, (items) => {
            console.log('Stored Hardware List: ', items)
            this.setState({
              hardwareList: items
            }, () => {
              this.calculateTotal()
              console.log('Stored Hardware List - State: ', this.state.hardwareList)
            })
          })

          if (this.state.freeShipping == 1) {
            alert('Customer is due free shipping from an online review!')
          }
        })
      }
      console.log('CompanyId: ', props.companyId)
      props.companies.loadCompanyDetails({ id: props.companyId, hash: localStorage.getItem('userHash') }, (company) => {
        this.state.billingAddressId = company.defaultBillingAddressId
        this.state.shippingAddressId = company.defaultShippingAddressId
        props.addresses.loadCompanyBillingAddresses(props.companyId)
        props.addresses.loadCompanyShippingAddresses(props.companyId)

        if (props.companies.details.freeShipping == 1) {
          alert('Customer is due free shipping from an online review!')
        }
        
        this.calculateTotal()
      })

      props.backends.loadAllBackends()
      props.carriers.loadAllCarriers()
      props.paymentintervals.loadAllPaymentIntervals()
      props.terms.loadAllTerms()
      props.shippingtypes.loadAllShippingTypes()
      props.agreements.loadAllAgreements()

      this.setState({
        loadableState: false
      })
    })
  }

  // TOTAL CALCULATIONS
  calculateTotal() {
    let hardwareTotalTaxable = parseFloat(this.getHardwareTotalTaxable())
    let hardwareTotal = parseFloat(this.getHardwareTotal())
    let taxableTotal = parseFloat(hardwareTotalTaxable) + parseFloat(this.state.accessoriesTotal)
    let tax = taxableTotal * (parseFloat(this.state.taxRate) / 100)

    if (this.props.companies.details.taxable == 0) {
      tax = 0.00
    }

    let total = hardwareTotal + parseFloat(this.state.accessoriesTotal) + tax + parseFloat(this.state.activationCostDetail) + parseFloat(this.state.shippingCostDetail)
    let serviceDetailsTotal = parseFloat(this.state.serviceTotal) + parseFloat(this.state.featuresTotal)

    this.setState({
      invoiceTax: tax.toFixed(2),
      invoiceTotal: total.toFixed(2),
      serviceDetailsTotal: serviceDetailsTotal.toFixed(2)
    })
  }

  calculateHardwareTotal(data) {
    if (data.length > 0) {
      let total = 0
      for (let i = 0; i < data.length; i++) {
        total += data[i].cost * data[i].quantity
      }

      this.setState({
        hardwareTotal: total.toFixed(2),
      }, () => { this.calculateTotal() })
    }
    else {
      this.setState({
        hardwareTotal: 0.00,
      }, () => { this.calculateTotal() })
    }
  }

  getHardwareTotal() {
    let total = 0

    for (let i = 0; i < this.state.hardwareList.length; i++) {
      let ih = this.state.hardwareList[i]
      total += parseFloat(ih.quantity * ih.cost)
    }
    return total
  }

  getHardwareTotalTaxable() {
    let total = 0

    for (let i = 0; i < this.state.hardwareList.length; i++) {
      let ih = this.state.hardwareList[i]
      if (ih.taxExempt == 0) {
        total += parseFloat(ih.quantity * ih.cost)
      }
    }

    return total
  }

  // HARDWARE STATE ARRAY MUTATIONS
  addInvoiceItem() {
    let taxExempt = (document.getElementById('taxExempt').checked ? 1 : 0)
    let itemCost = (document.getElementById('hardwareCost').value > 0 ? document.getElementById('hardwareCost').value : 0)
    let description = (this.state.addHardwareDescription ? this.state.addHardwareDescription : '')

    let row = {
      hardwareId: this.state.addHardwareId,
      quantity: document.getElementById('hardwareQuantity').value,
      cost: itemCost,
      serviceCost: 0,
      hardwareName: this.state.addHardwareName,
      description: description,
      taxExempt: taxExempt
    }

    var arrayvar = this.state.hardwareList.slice()
    arrayvar.push(row)
    this.setState({
      hardwareList: arrayvar
    }, () => {
      this.calculateHardwareTotal(this.state.hardwareList)
    })

    this.closeHardwareModal()
  }

  editInvoiceItem() {
    let description = (this.state.editHardwareDescription ? this.state.editHardwareDescription : '')

    let row = {
      hardwareId: this.state.editHardwareId,
      description: description,
      quantity: this.state.editHardwareQuantity,
      cost: this.state.editHardwareCost,
      serviceCost: 0,
      hardwareName: this.state.editHardwareName,
      taxExempt: this.state.editHardwareTaxExempt
    }

    //Remove existing item from hardware state array
    if (~this.state.originalIndexId) {

      let updatedHardwareList = this.state.hardwareList;
      updatedHardwareList[this.state.originalIndexId] = row;
      this.calculateHardwareTotal(updatedHardwareList)
      this.setState({
        hardwareList: updatedHardwareList
      });
    } else {
      alert('Invalid indexId.  Please refresh and try again.')
    }

    this.closeEditHardwareModal()
  }

  deleteInvoiceItem(id, indexId) {
    if (confirm('Are you sure you want to delete this hardware?')) {
      this.state.hardwareList.splice(indexId, 1)

      this.setState({
        hardwareList: this.state.hardwareList
      }, () => {
        this.calculateHardwareTotal(this.state.hardwareList)
      })
    }
  }

  // PROCESS SAVE QUOTE REQUESTS
  processInvoiceRequest() {
    if (this.props.type == 'new') {
      this.processSaveInvoiceRequest()
    } else {
      this.processUpdateInvoiceRequest()
    }
  }

  processSaveInvoiceRequest() {

    this.setState({
      loadableState: true
    })

    if (this.validateInvoiceForm()) {
      let closeDate = this.state.closeDateDetail

      if (closeDate == '') {
        let now = new Date()
        closeDate = now.yyyymmdd()
      }

      const invoiceInfo = {
        accessoriesTotal: this.state.accessoriesTotal,
        activation: this.state.activationCostDetail,
        agreementId: this.state.selectedAgreementId,
        backendId: this.state.selectedBackendId,
        billingAddressId: this.state.billingAddressId,
        carrierId: this.state.selectedCarrierId,
        closeDate: closeDate,
        closePercentage: this.state.closePercentageDetail,
        companyId: this.props.companyId,
        contractTermId: this.state.selectedContractTermId,
        paymentTermId: this.state.selectedPaymentTermId,
        featureTotal: this.state.featuresTotal,
        hardwareTotal: this.state.hardwareTotal,
        hash: localStorage.getItem('userHash'),
        monthlyTotal: this.state.serviceDetailsTotal,
        note: this.state.noteDetail,
        oneTimeTotal: this.state.invoiceTotal,
        paymentIntervalId: this.state.selectedPaymentIntervalId,
        serviceId: this.state.selectedServiceId,
        serviceTotal: this.state.serviceTotal,
        shippingAddressId: this.state.shippingAddressId,
        shippingCost: this.state.shippingCostDetail,
        shippingTypeId: this.state.selectedShippingTypeId,
        status: 1,
        taxTotal: this.state.invoiceTax,
        taxRateId: this.state.selectedTaxRateId,
        quoteType: this.state.quoteType,
        oneTimetotal: this.state.invoiceTotal
      }

      this.props.saveInvoice(invoiceInfo, (invoice) => {
        if (invoice.id) {
          if (this.state.hardwareList != null) {
            this.processSaveInvoiceItems(invoice.id, this.state.hardwareList, () => {
              this.props.companies.loadCompanyQuotes(this.props.companyId)
              //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
              this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 1, invoice.id, 1, this.props.companyId)

              if (this.props.companies.details.freeShipping == 1 && invoiceInfo.shippingCost == 0) {
                if (confirm('This company is due free shipping from an online review and you charged no shipping cost on this invoice.  Do you want to remove the free shipping flag from the customer account?')) {
                  console.log('Removing free shipping flag...')
                  const params = {
                    id: this.props.companyId,
                    freeShipping: 0
                  }
                  this.props.companies.updateFreeShippingStatus(params)
                }
              }

              alert('Invoice successfully saved!')
              this.setState({
                loadableState: false
              }, () => {
                browserHistory.push('/company/invoices/' + this.props.companyId)
              })
            })
          }
        } else {
          alert('Error saving invoice.  Please try again.')
          this.setState({
            loadableState: false
          })
        }
      })
    }
    else {
      alert('Please check the form.  Required data is missing.')
      this.setState({
        loadableState: false
      })
    }
  }

  processUpdateInvoiceRequest() {
    this.setState({
      loadableState: true
    })

    if (this.validateInvoiceForm()) {
      // set default close date if necessary
      let closeDate = this.state.closeDateDetail

      if (closeDate == '') {
        let now = new Date()
        closeDate = now.yyyymmdd()
      }

      const invoiceInfo = {
        accessoriesTotal: this.state.accessoriesTotal,
        activation: this.state.activationCostDetail,
        agreementId: this.state.selectedAgreementId,
        backendId: this.state.selectedBackendId,
        billingAddressId: this.state.billingAddressId,
        carrierId: this.state.selectedCarrierId,
        closeDate: closeDate,
        closePercentage: this.state.closePercentageDetail,
        companyId: this.state.companyId,
        contractTermId: this.state.selectedContractTermId,
        paymentTermId: this.state.selectedPaymentTermId,
        featureTotal: this.state.featuresTotal,
        hardwareTotal: this.state.hardwareTotal,
        hash: localStorage.getItem('userHash'),
        monthlyTotal: this.state.serviceDetailsTotal,
        note: this.state.noteDetail,
        oneTimeTotal: this.state.invoiceTotal,
        paymentIntervalId: this.state.selectedPaymentIntervalId,
        invoiceId: this.props.invoiceId,
        serviceId: this.state.selectedServiceId,
        serviceTotal: this.state.serviceTotal,
        shippingAddressId: this.state.shippingAddressId,
        shippingCost: this.state.shippingCostDetail,
        shippingTypeId: this.state.selectedShippingTypeId,
        status: 1,
        taxTotal: this.state.invoiceTax,
        taxRateId: this.state.selectedTaxRateId,
        quoteType: this.state.quoteType,
        oneTimeTotal: this.state.invoiceTotal
      }

      this.props.updateInvoice(invoiceInfo, (invoice) => {
        this.processDeleteInvoiceItems(() => {
          if (this.state.hardwareList != null) {
            this.processSaveInvoiceItems(invoiceInfo.invoiceId, this.state.hardwareList, () => {
              alert('Invoice successfully updated.');
              browserHistory.push('/company/invoices/' + this.props.companyId);

              /*
              //Reload Hardware List and set to State
              this.setState({
                hardwareList: []
              }, () => {
              })

              this.props.loadInvoiceItems(invoiceInfo.invoiceId, this.props.quickbooks.qbItemList, (items) => {
                console.log('Hardware List - Saved after Update: ', items)
                this.setState({
                  hardwareList: items
                }, () => {
                  this.calculateTotal()
                  console.log('Hardware List - State after Update: ', this.state.hardwareList)
                })
              })

              alert('Invoice successfully updated!')

              this.setState({
                loadableState: false
              })
              */
            })
          }
        })

        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 1, this.props.invoiceId, 1, this.state.companyId)
      })
    } else {
      alert('Please check the form.  Required data is missing.')
      this.setState({
        loadableState: false
      })
    }
  }

  processSaveInvoiceItems(invoiceId, hardwareList, callback) {
    console.log('Hardware List - To Be Saved: ', this.state.hardwareList)
    let promises = hardwareList.map((h, i) => {
      return new Promise((resolve) => {
        console.log('Index: ', i)
        console.log('Hardware Item Saved: ', h)
        h.invoiceId = invoiceId
        h.sortId = i
        this.props.invoices.addInvoiceHardware(h, () => {
          resolve()
        })
      })
    })

    Promise.all(promises).then(() => {
      if (callback) {
        callback()
      }
    })
  }

  processDeleteInvoiceItems(callback) {
    let promises = []
    if (this.props.invoices.invoiceHardware) {
      promises = this.props.invoices.invoiceHardware.map((h) => {
        return new Promise((resolve) => {
          this.props.invoices.deleteInvoiceHardware({
            id: h.id,
            hash: localStorage.getItem('userHash')
          }, () => {
            resolve()
          })
        })
      })
    }

    Promise.all(promises).then(() => {
      if (callback) {
        callback()
      }
    })
  }

  processDeleteInvoiceRequest(cell, row) {
    if (confirm('Are you sure you want to delete this invoice?  This action cannot be undone!')) {
      this.props.invoices.deleteInvoice(cell)
    }
  }

  // FORM VALIDATION FUNCTIONS
  validateInvoiceForm() {
    if (this.getQuoteTypeValidationState() == 'error') {
      return false
    }

    if (this.getBillingAddressValidationState() == 'error') {
      return false
    }

    if (this.getShippingAddressValidationState() == 'error') {
      return false
    }

    if (this.getBackendValidationState() == 'error') {
      return false
    }

    if (this.getCarrierValidationState() == 'error') {
      return false
    }

    if (this.getTermValidationState() == 'error') {
      return false
    }

    if (this.getPaymentTermValidationState() == 'error') {
      return false
    }

    if (this.getAgreementValidationState() == 'error') {
      return false
    }

    if (this.getTaxRateValidationState() == 'error') {
      return false
    }

    return true
  }

  getQuoteTypeValidationState() {
    if (this.state && this.state.quoteType != '') {
      return 'success'
    } else {
      return 'error'
    }
  }

  getBillingAddressValidationState() {
    if (this.state && this.state.billingAddressId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getShippingAddressValidationState() {
    if (this.state && this.state.shippingAddressId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getBackendValidationState() {
    if (this.state && this.state.selectedBackendId > 0 || this.state.quoteType == 'accessory') {
      return 'success'
    } else {
      return 'error'
    }
  }

  getCarrierValidationState() {
    if (this.state && this.state.selectedCarrierId > 0 || this.state.quoteType == 'accessory') {
      return 'success'
    } else {
      return 'error'
    }
  }

  getTermValidationState() {
    if (this.state && this.state.selectedContractTermId > 0 || this.state.quoteType == 'accessory') {
      return 'success'
    } else {
      return 'error'
    }
  }

  getPaymentTermValidationState() {
    if (this.state && this.state.selectedPaymentTermId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getAgreementValidationState() {
    if (this.state && this.state.selectedAgreementId > 0 || this.state.quoteType == 'accessory') {
      return 'success'
    } else {
      return 'error'
    }
  }

  getTaxRateValidationState() {
    if (this.state && this.state.selectedTaxRateId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  // STATE CHANGE FUNCTIONS
  invoiceTypeChanged(e) {
    this.setState({
      quoteType: e.target.value
    })
  }

  billingAddressChanged(e) {
    if (e.target.value != '') {
      let addressId = e.target.value

      this.setState({
        billingAddressId: e.target.value
      })
    }
  }

  shippingAddressChanged(e) {
    if (e.target.value != '') {
      this.setState({
        shippingAddressId: e.target.value
      })
    }
  }

  onActivationChanged(e) {
    this.setState({
      activationCostDetail: e.target.value
    }, (data) => {
      this.calculateTotal()
    })
  }

  onShippingCostChanged(e) {
    this.setState({
      shippingCostDetail: e.target.value
    }, (data) => {
      this.calculateTotal()
    })
  }

  onNoteChanged(e) {
    this.setState({
      noteDetail: e.target.value
    })
  }

  onCloseDateChanged(value, formattedValue) {
    if (formattedValue == null) {
      formattedValue = ''
    }

    this.setState({
      closeDateDetail: formattedValue
    })
  }

  onClosePercentageChanged(e) {
    this.setState({
      closePercentageDetail: e.target.value
    })
  }

  onBackendChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedBackendId: e[0].id,
        selectedBackendName: e[0].name
      })
    } else {
      this.setState({
        selectedBackendId: 0,
        selectedBackendName: ''
      })
    }
  }

  onServiceChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedServiceId: e[0].id,
        selectedServiceName: e[0].name
      })
    } else {
      this.setState({
        selectedServiceId: 0,
        selectedServiceName: ''
      })
    }
  }

  onPaymentIntervalChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedPaymentIntervalId: e[0].id,
        selectedPaymentIntervalName: e[0].name
      })
    } else {
      this.setState({
        selectedPaymentIntervalId: 0,
        selectedPaymentIntervalName: ''
      })
    }
  }

  onCarrierChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedCarrierId: e[0].id,
        selectedCarrierName: e[0].name
      })
    } else {
      this.setState({
        selectedCarrierId: 0,
        selectedCarrierName: ''
      })
    }
  }

  onContractTermChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedContractTermId: e[0].id,
        selectedContractTermName: e[0].terms
      })
    } else {
      this.setState({
        selectedContractTermId: 0,
        selectedContractTermName: ''
      })
    }
  }

  onPaymentTermChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedPaymentTermId: e[0].id,
        selectedPaymentTermName: e[0].name
      })
    } else {
      this.setState({
        selectedPaymentTermId: 0,
        selectedPaymentTermName: ''
      })
    }
  }

  onShippingTypeChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedShippingTypeId: e[0].id,
        selectedShippingTypeName: e[0].name
      })
    } else {
      this.setState({
        selectedShippingTypeId: 0,
        selectedShippingTypeName: ''
      })
    }
  }

  onAgreementChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedAgreementId: e[0].id,
        selectedAgreementName: e[0].name
      })
    } else {
      this.setState({
        selectedAgreementId: 0,
        selectedAgreementName: ''
      })
    }
  }

  onTaxRateChanged(e) {
    const qbTaxRatesList = this.props.quickbooks.qbTaxRatesList

    if (e.length > 0 && qbTaxRatesList.length > 0) {
      for (var i = 0; i < qbTaxRatesList.length; i++) {
        if (e[0].id == qbTaxRatesList[i].id) {
          this.setState({
            selectedTaxRateId: e[0].id,
            selectedTaxRateName: e[0].name,
            taxRate: qbTaxRatesList[i].taxRate
          }, () => {
            this.calculateTotal()
          })
          break
        }
      }
    } else {
      this.setState({
        selectedTaxRateId: 0,
        selectedTaxRateName: '',
        taxRate: 0
      }, () => {
        this.calculateTotal()
      })
    }
  }

  onHardwareChanged(e) {
    if (e.length > 0) {
      this.setState({
        addHardwareId: e[0].Id,
        addHardwareName: e[0].Name,
        addHardwareDescription: e[0].Description,
        addHardwareCost: e[0].Cost
      })
    } else {
      this.setState({
        addHardwareId: 0,
        addHardwareName: '',
        addHardwareDescription: '',
        addHardwareCost: 0
      })
    }
  }

  onHardwareDescriptionChanged(e) {
    this.setState({
      addHardwareDescription: e.target.value
    })
  }

  onHardwareCostChanged(e) {
    this.setState({
      addHardwareCost: e.target.value
    })
  }

  onEditHardwareItemChanged(e) {
    console.log('Edit Hardware Item E: ', e[0])
    if (e.length > 0) {
      this.setState({
        editHardwareId: e[0].Id,
        editHardwareName: e[0].Name,
        editHardwareDescription: e[0].Description,
        editHardwareCost: e[0].Cost
      })
    } else {
      this.setState({
        editHardwareId: 0,
        editHardwareName: '',
        editHardwareDescription: '',
        editHardwareCost: 0
      })
    }
  }

  onEditHardwareQuantityChanged(e) {
    this.setState({
      editHardwareQuantity: e.target.value
    })
  }

  onEditHardwareDescriptionChanged(e) {
    this.setState({
      editHardwareDescription: e.target.value
    })
  }

  onEditHardwareCostChanged(e) {
    console.log('E: ', e.target.value)
    this.setState({
      editHardwareCost: e.target.value
    })
  }

  onEditHardwareTaxExemptChanged(e) {
    this.setState({
      editHardwareTaxExempt: e.target.checked ? 1 : 0
    })
  }

  openHardwareModal() {
    this.setState({
      showHardwareModal: true
    })
  }

  closeHardwareModal() {
    this.setState({
      showHardwareModal: false,
      addHardwareCost: '',
      addHardwareDescription: ''
    })
  }

  //openEditHardwareModal(e, cell, indexId) {
  openEditHardwareModal(indexId) {
    this.setState({
      showEditHardwareModal: true,
      originalIndexId: indexId
    })

    this.setState({
      editHardwareId: this.state.hardwareList[indexId].hardwareId,
      editHardwareName: this.state.hardwareList[indexId].hardwareName,
      editHardwareDescription: this.state.hardwareList[indexId].description,
      editHardwareQuantity: this.state.hardwareList[indexId].quantity,
      editHardwareCost: this.state.hardwareList[indexId].cost,
      editHardwareTaxExempt: this.state.hardwareList[indexId].taxExempt
    })
  }

  closeEditHardwareModal() {
    this.setState({
      showEditHardwareModal: false,
      editHardwareId: 0,
      editHardwareName: '',
      editHardwareDescription: '',
      editHardwareQuantity: 0,
      editHardwareCost: 0,
      editHardwareTaxExempt: 0,
      originalIndexId: -1
    })
  }

  // DATA FORMATS FOR RENDER
  processInvoiceRequestText() {
    if (this.props.type == 'new') {
      return ' Save'
    } else {
      return ' Update'
    }
  }

  /*
  formatHardware(cell, row, extra, id) {
      return (
      <div>
          <Button bsSize="small" bsStyle="warning" onClick={ (e) => { this.openEditHardwareModal(e, cell, id) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button>
          <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteInvoiceItem(cell, id) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
      )
  }
  */

  formatTaxExempt(cell, row) {
    return (cell == 1 ? 'Yes' : 'No')
  }

  onSortEnd({ oldIndex, newIndex }) {
    console.log('oldIndex: ', oldIndex)
    console.log('newIndex: ', newIndex)
    this.setState({
      hardwareList: arrayMove(this.state.hardwareList, oldIndex, newIndex),
    }, () => {
      console.log('Newly Sorted Hardware List: ', this.state.hardwareList)
    });
  };

  render() {

    const invoiceTypeDropdown = (
      <InputGroup bsSize="small">
        <FormControl componentClass="select" value={this.state.quoteType} id="defaultQuoteType" onChange={this.invoiceTypeChanged.bind(this)}>
          <option value={''}>Select Quote Type</option>
          <option value={'bhph'}>BHPH</option>
          <option value={'fleet'}>Fleet</option>
          <option value={'accessory'}>Acessory</option>
        </FormControl>
      </InputGroup>
    )

    const billingAddressDropdown = (
      <InputGroup bsSize="small">
        <FormControl componentClass="select" value={this.state.billingAddressId} id={"defaultBillingAddressId"} onChange={this.billingAddressChanged.bind(this)}>
          <option value="">Default Billing Address</option>
          {
            this.props.addresses.billingAddresses.map((address) => {
              return <option value={address.id} key={'billingAddresses_'+address.id}>{address.address}</option>
            })
          }
        </FormControl>
      </InputGroup>
    )

    const shippingAddressDropdown = (
      <InputGroup bsSize="small">
        <FormControl componentClass="select" value={this.state.shippingAddressId} id="defaultShippingAddressId" onChange={this.shippingAddressChanged.bind(this)}>
          <option value="">Default Shipping Address</option>
          {
            this.props.addresses.shippingAddresses.map((address) => {
              return <option value={address.id} key={'shippingAddress_'+address.id}>{address.address}</option>
            })
          }
        </FormControl>
      </InputGroup>
    )

    /*
    let hardwareTable = ''

    if (this.state.hardwareList.length > 0) {
        let hardwareTableContent = (
            <BootstrapTable
                data={ this.state.hardwareList }
                striped={ true }
                hover={ true }
                pagination={ true }
                bordered={ false }
            >
            <TableHeaderColumn width="150" dataField="hardwareName" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>Item</TableHeaderColumn>
            <TableHeaderColumn width="150" dataField="quantity" dataSort={ true }>Quantity</TableHeaderColumn>
            <TableHeaderColumn width="150" dataField="cost" dataSort={ true }>Cost</TableHeaderColumn>
            <TableHeaderColumn width="150" dataField="taxExempt" dataSort={ true } dataFormat={ this.formatTaxExempt.bind(this) }>Tax Exempt</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="hardwareId" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatHardware.bind(this) }>Delete</TableHeaderColumn>
            </BootstrapTable>
        )

        hardwareTable = <Collapsible title={ 'Items' } content={ hardwareTableContent } />
    }
    */

    const invoiceDetailSection = (
      <div>
        <div className="col-md-6 col-sm-6 col-xs-12">
          <Panel bsStyle="primary" header="Invoice Details">
            <Form horizontal name="hardwareForm">
              <FormGroup>
                <Col componentClass={ControlLabel} xs={2}>Items:</Col>
                <Col xs={10}>
                  <InputGroup>
                    <InputGroup.Addon>$</InputGroup.Addon>
                    <FormControl type="text" value={this.state.hardwareTotal} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={2}>Shipping:</Col>
                <Col xs={10}>
                  <InputGroup>
                    <InputGroup.Addon>$</InputGroup.Addon>
                    <FormControl type="text" value={this.state.shippingCostDetail} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={2}>Tax ({parseFloat(this.state.taxRate)}%):</Col>
                <Col xs={10}>
                  <InputGroup>
                    <InputGroup.Addon>$</InputGroup.Addon>
                    <FormControl type="text" value={this.state.invoiceTax} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={2}>Total:</Col>
                <Col xs={10}>
                  <InputGroup>
                    <InputGroup.Addon>$</InputGroup.Addon>
                    <FormControl type="text" value={this.state.invoiceTotal} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
            </Form>
          </Panel>
        </div>
        <div className="col-md-6 col-sm-6 col-xs-12">
          <Panel bsStyle="primary" header="Service Contract Details">
            <Form horizontal name="serviceContractForm">
              <FormGroup>
                <Col componentClass={ControlLabel} xs={3}>Software Platform:</Col>
                <Col xs={9}>
                  <InputGroup>
                    <FormControl type="text" value={this.state.selectedBackendName} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={3}>Carrier:</Col>
                <Col xs={9}>
                  <InputGroup>
                    <FormControl type="text" value={this.state.selectedCarrierName} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={3}>Contract Term:</Col>
                <Col xs={9}>
                  <InputGroup>
                    <FormControl type="text" value={this.state.selectedContractTermName} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={3}>Payment Term:</Col>
                <Col xs={9}>
                  <InputGroup>
                    <FormControl type="text" value={this.state.selectedPaymentTermName} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={3}>Tax Rate:</Col>
                <Col xs={9}>
                  <InputGroup>
                    <FormControl type="text" value={this.state.selectedTaxRateName} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} xs={3}>Agreement:</Col>
                <Col xs={9}>
                  <InputGroup>
                    <FormControl type="text" value={this.state.selectedAgreementName} disabled />
                  </InputGroup>
                </Col>
              </FormGroup>
            </Form>
          </Panel>
        </div>
      </div>
    )

    const buildQuoteSection = (
      <div>
        <div className="col-md-4 col-sm-4 col-xs-12">
          <PanelGroup>
            <Panel header="Invoice Options">
              <Form horizontal name="invoiceOptionForm">
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Quote Type:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getQuoteTypeValidationState()}>
                      {invoiceTypeDropdown}
                    </FormGroup>
                  </Col>
                </FormGroup>
              </Form>
            </Panel>
            <Panel header="Addresses">
              <Form horizontal name="addressForm">
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Billing Address:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getBillingAddressValidationState()}>
                      {billingAddressDropdown}
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Shipping Address:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getShippingAddressValidationState()}>
                      {shippingAddressDropdown}
                    </FormGroup>
                  </Col>
                </FormGroup>
              </Form>
            </Panel>
          </PanelGroup>
        </div>
        <div className="col-md-4 col-sm-4 col-xs-12">
          <PanelGroup>
            <Panel header="Service Options">
              <Form horizontal name="serviceOptionsForm">
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Backend:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getBackendValidationState()}>
                      <Typeahead clearButton labelKey="name" options={this.props.backends.data && this.props.backends.data.length > 0 ? this.props.backends.data : [{ id: 0, name: 'Loading...' }]} onChange={this.onBackendChanged.bind(this)} selected={[{ id: this.state.defaultBackendId, name: this.state.defaultBackendName }]} placeholder="Choose a backend..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Carrier:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getCarrierValidationState()}>
                      <Typeahead clearButton labelKey="name" options={this.props.carriers.data && this.props.carriers.data.length > 1 ? this.props.carriers.data : [{ id: 0, name: 'Loading...' }]} onChange={this.onCarrierChanged.bind(this)} selected={[{ id: this.state.defaultCarrierId, name: this.state.defaultCarrierName }]} placeholder="Choose a carrier..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
              </Form>
            </Panel>
            <Panel header="Terms and Taxes">
              <Form horizontal name="invoiceOptions">
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Payment Term:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getPaymentTermValidationState()}>
                      <Typeahead clearButton labelKey="name" options={this.props.quickbooks.qbTermsList && this.props.quickbooks.qbTermsList.length > 0 ? this.props.quickbooks.qbTermsList : [{ id: 0, name: 'Loading...' }]} onChange={this.onPaymentTermChanged.bind(this)} selected={[{ id: this.state.defaultPaymentTermId, name: this.state.defaultPaymentTermName }]} placeholder="Choose a payment term..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Contract Term:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getTermValidationState()}>
                      <Typeahead clearButton labelKey="terms" options={this.props.terms.data && this.props.terms.data.length > 1 ? this.props.terms.data : [{ id: 0, name: 'Loading...' }]} onChange={this.onContractTermChanged.bind(this)} selected={[{ id: this.state.defaultContractTermId, terms: this.state.defaultContractTermName }]} placeholder="Choose a contract term..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ControlLabel}>Tax Rate:</Col>
                  <Col sm={8}>
                    <FormGroup validationState={this.getTaxRateValidationState()}>
                      <Typeahead clearButton labelKey="name" options={this.props.quickbooks.qbTaxRatesList && this.props.quickbooks.qbTaxRatesList.length > 0 ? this.props.quickbooks.qbTaxRatesList : [{ id: 0, name: 'Loading...' }]} onChange={this.onTaxRateChanged.bind(this)} selected={[{ id: this.state.defaultTaxRateId, name: this.state.defaultTaxRateName }]} placeholder="Choose a tax rate..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
              </Form>
            </Panel>
          </PanelGroup>
        </div>
        <div className="col-md-4 col-sm-4 col-xs-12">
          <Panel header="Notes">
            <Form horizontal name="addNoteForm">
              <FormGroup>
                <Col sm={4} componentClass={ControlLabel}>Shipping Type:</Col>
                <Col sm={8}>
                  <FormGroup>
                    <Typeahead clearButton labelKey="name" options={this.props.shippingtypes.data && this.props.shippingtypes.data.length > 1 ? this.props.shippingtypes.data : [{ id: 0, name: 'Loading...' }]} onChange={this.onShippingTypeChanged.bind(this)} selected={[{ id: this.state.defaultShippingTypeId, name: this.state.defaultShippingTypeName }]} placeholder="Choose a shipping type..." />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={4} componentClass={ControlLabel}>Shipping Cost:</Col>
                <Col sm={8}>
                  <FormGroup>
                    <FormControl type="text" placeholder="Shipping Cost" id="addShippingCost" value={this.state.shippingCostDetail} onChange={this.onShippingCostChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={4} componentClass={ControlLabel}>Note:</Col>
                <Col sm={8}>
                  <FormGroup>
                    <FormControl componentClass="textarea" placeholder="Note..." id="addNote" value={this.state.noteDetail} onChange={this.onNoteChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={4} componentClass={ControlLabel}>Est. Closing Date:</Col>
                <Col sm={8}>
                  <FormGroup>
                    <DatePicker id="addCloseDate" dateFormat="YYYY-MM-DD" value={this.state.closeDateDetail} onChange={this.onCloseDateChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={4} componentClass={ControlLabel}>Est. Closing Percentage:</Col>
                <Col sm={8}>
                  <FormGroup>
                    <FormControl type="text" placeholder="Closing Percentage" id="addClosePercentage" value={this.state.closePercentageDetail} onChange={this.onClosePercentageChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={4} componentClass={ControlLabel}>Agreement:</Col>
                <Col sm={8}>
                  <FormGroup validationState={this.getAgreementValidationState()}>
                    <Typeahead clearButton labelKey="name" options={this.props.agreements.data && this.props.agreements.data.length > 1 ? this.props.agreements.data : [{id:0,name:'Loading...'}]} onChange={this.onAgreementChanged.bind(this)} selected={[{ id: this.state.defaultAgreementId, name: this.state.defaultAgreementName }]} placeholder="Choose an agreement..." />
                  </FormGroup>
                </Col>
              </FormGroup>
            </Form>
          </Panel>
        </div>
        <div style={{ clear: 'both' }}></div>
        <div>
          <Button bsStyle="info" onClick={this.openHardwareModal.bind(this)}>Add Item</Button>
        </div>
        <div style={{ clear: 'both' }}></div>
        <div style={{ float: 'right' }}>
          <Button bsStyle="danger" onClick={this.processDeleteInvoiceRequest.bind(this)}><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
          <Button bsStyle="success" onClick={this.processInvoiceRequest.bind(this)}><i className="fa fa-floppy-o" aria-hidden="true"></i>{this.processInvoiceRequestText()} </Button>

        </div>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <CompanyNavigation activeKey="4" companyId={this.props.companyId} companyStateId={this.props.companies.details.companyStateId} companyName={this.props.companies.details.name} />
        <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
          <div>
            <div>
              <Collapsible title={'Invoice Details'} content={invoiceDetailSection} />
              <Collapsible title={'Build Invoice'} content={buildQuoteSection} />
            </div>
            { /*
                        <div>
                            { hardwareTable }
                        </div>
                        */ }
            <div>
              <Collapsible title="Items" content={
                <SortableList
                  items={this.state.hardwareList}
                  onSortEnd={this.onSortEnd.bind(this)}
                  useDragHandle={true}
                  openEditHardwareModal={this.openEditHardwareModal.bind(this)}
                  deleteInvoiceItem={this.deleteInvoiceItem.bind(this)}
                  formatTaxExempt={this.formatTaxExempt.bind(this)}
                />
              } />
            </div>
            <Modal show={this.state.showHardwareModal} onHide={this.closeHardwareModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>Add Item</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form horizontal name="addHardwareForm">
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Type:</Col>
                    <Col sm={8}>
                      <FormGroup>
                        <Typeahead clearButton labelKey="Name" options={this.props.quickbooks.qbItemList} onChange={this.onHardwareChanged.bind(this)} placeholder="Choose an item type..." />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Description:</Col>
                    <Col sm={8}><FormControl type="text" placeholder="Description" id="hardwareDescription" onChange={this.onHardwareDescriptionChanged.bind(this)} value={this.state.addHardwareDescription} /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Quantity:</Col>
                    <Col sm={8}><FormControl type="text" placeholder="Quantity" id="hardwareQuantity" /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Cost:</Col>
                    <Col sm={8}><FormControl type="text" placeholder="Cost" id="hardwareCost" onChange={this.onHardwareCostChanged.bind(this)} value={this.state.addHardwareCost} /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}></Col>
                    <Col sm={8}><Checkbox inline id="taxExempt">Tax Exempt</Checkbox></Col>
                  </FormGroup>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button bsStyle="danger" onClick={this.closeHardwareModal.bind(this)}>Close</Button>
                <Button bsStyle="success" onClick={this.addInvoiceItem.bind(this)}>Add</Button>
              </Modal.Footer>
            </Modal>
            <Modal show={this.state.showEditHardwareModal} onHide={this.closeEditHardwareModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>Edit Item</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form horizontal name="editHardwareForm">
                  <FormGroup>

                    <Col sm={4} componentClass={ControlLabel}>Type:</Col>
                    <Col sm={8}>
                      <FormGroup>
                        <Typeahead clearButton labelKey="Name" options={this.props.quickbooks.qbItemList} onChange={this.onEditHardwareItemChanged.bind(this)} selected={[{ Id: this.state.editHardwareId, Name: this.state.editHardwareName, Description: this.state.editHardwareDescription, Cost: this.state.editHardwareCost }]} placeholder="Choose an item type..." />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Description:</Col>
                    <Col sm={8}><FormControl type="text" placeholder="Description" onChange={this.onEditHardwareDescriptionChanged.bind(this)} value={this.state.editHardwareDescription} /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Quantity:</Col>
                    <Col sm={8}><FormControl type="text" placeholder="Quantity" onChange={this.onEditHardwareQuantityChanged.bind(this)} value={this.state.editHardwareQuantity} /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}>Cost:</Col>
                    <Col sm={8}><FormControl type="text" placeholder="Cost" onChange={this.onEditHardwareCostChanged.bind(this)} value={this.state.editHardwareCost} /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={4} componentClass={ControlLabel}></Col>
                    <Col sm={8}><Checkbox inline checked={(this.state.editHardwareTaxExempt == 1) ? true : false} onChange={this.onEditHardwareTaxExemptChanged.bind(this)} >Tax Exempt</Checkbox></Col>
                  </FormGroup>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button bsStyle="danger" onClick={this.closeEditHardwareModal.bind(this)}>Close</Button>
                <Button bsStyle="success" onClick={this.editInvoiceItem.bind(this)}>Update</Button>
              </Modal.Footer>
            </Modal>
          </div>
        </Loadable>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/invoicedetails.js